import React from 'react';
import { JobsListSecond } from './JobsListSecond';

export const JobsListsSecond = () => {
    return (
        <div>
            <JobsListSecond />
        </div>
    );
};
